import type { RootState } from '@generalTypes/rootStateTypes';
// @ts-ignore shared component package has no published TS declarations
import { Modal } from '@kathondvla/react-shared-components/src/components';
import { buildSnapshotChanges } from '@newStore/documentSnapshot/documentSnapshotHelpers';
import React, { useEffect, useState } from 'react';
import { useStore } from 'react-redux';
import './modals.scss';

interface SnapshotChangesModalProps {
  onClose?: () => void;
}

const SnapshotChangesModal: React.FC<SnapshotChangesModalProps> = ({ onClose = () => {} }) => {
  const store = useStore<RootState>();
  const [changesHtml, setChangesHtml] = useState<string | null>(null);

  useEffect(() => {
    // Defer the heavy tree computation so the modal and its spinner paint first.
    const timeoutId = setTimeout(() => {
      setChangesHtml(buildSnapshotChanges(store.getState(), true));
    }, 0);
    return () => clearTimeout(timeoutId);
  }, [store]);

  const handleContentClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;

    // Collapse / expand a whole section (TOEGEVOEGD / GEWIJZIGD / VERWIJDERD) via its header.
    const sectionHeader = target.closest('p.snapshot-change-section');
    if (sectionHeader) {
      sectionHeader.classList.toggle('collapsed');
      return;
    }

    // Collapse / expand a node's child subtree via its caret.
    const caret = target.closest('.snapshot-change-caret');
    if (caret) {
      caret.closest('li.has-children')?.classList.toggle('collapsed');
      return;
    }

    // Node headers are aside links; close the modal when one is followed so the aside is visible.
    if (target.closest('a.snapshot-change-link')) {
      onClose();
    }
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title="Versiewijzigingen" onClose={onClose} />
      <Modal.Body>
        {changesHtml === null ? (
          <div
            className="well text-center"
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              height: '220px',
              justifyContent: 'center',
            }}
          >
            <div className="spinner-icon" style={{ margin: '0 0 12px', position: 'static' }} />
            <span>Versiewijzigingen worden berekend...</span>
          </div>
        ) : (
          <div className="snapshot-changes" onClick={handleContentClick}>
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: diff HTML is built from sanitized content */}
            <div dangerouslySetInnerHTML={{ __html: changesHtml }} />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-default" onClick={onClose}>
          Sluiten
        </button>
      </Modal.Footer>
    </div>
  );
};

export default SnapshotChangesModal;
